module.exports = __webpack_public_path__ + "static/michael-c2cec87137448427de1d8961b1b8983c.jpg";